import { MuiThemeProvider } from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import { SvgIcon } from 'components/Shared/SvgIcon';
import { WithStyles } from 'decorators/withStyles';
import { enPreviewMode } from 'interfaces/previewMode';
import * as React from 'react';
import { PureComponent } from 'react';

interface IState {
  previewMode: enPreviewMode;
}

interface IProps {
  classes?: any;
  onChangePreviewMode: Function;
}

@WithStyles(() => ({
  previewMode: {
    display: 'flex',
    cursor: 'pointer',
    margin: '8px auto'
  },
  previewModeOption: {
    padding: '4px 8px',
    backgroundColor: '#FFF',
    border: '1px solid #596375',
    fill: '#596375',
    textAlign: 'center',
    width: 65,
    '& svg': {
      width: 25,
      height: 25
    }
  },
  previewModeOptionFirst: {
    borderRadius: '4px 0 0 4px'
  },
  previewModeOptionSecond: {
    borderRadius: '0 4px 4px 0'
  },
  previewModeOptionSelected: {
    backgroundColor: '#596375',
    fill: '#FFF'
  }
}))
export default class PreviewMode extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = { previewMode: enPreviewMode.DESKTOP };
  }

  handleChangePreviewMode = (previewMode: enPreviewMode) => {
    this.setState({ previewMode });

    this.props.onChangePreviewMode(previewMode);
  };

  render() {
    const { previewMode } = this.state;
    const { classes } = this.props;

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <div className={classes.previewMode}>
          {/* tslint:disable-next-line:max-line-length */}
          <div
            onClick={this.handleChangePreviewMode.bind(this, enPreviewMode.DESKTOP)}
            className={`${classes.previewModeOption} ${classes.previewModeOptionFirst} ${
              previewMode === enPreviewMode.DESKTOP ? classes.previewModeOptionSelected : ''
            }`}
          >
            <SvgIcon name="desktop" />
          </div>
          {/* tslint:disable-next-line:max-line-length */}
          <div
            onClick={this.handleChangePreviewMode.bind(this, enPreviewMode.MOBILE)}
            className={`${classes.previewModeOption} ${classes.previewModeOptionSecond} ${
              previewMode === enPreviewMode.MOBILE ? classes.previewModeOptionSelected : ''
            }`}
          >
            <SvgIcon name="mobile" />
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}
